import { root } from "../../scope.js";
export const defineRegex = (regex, description) => root.defineRoot({
    domain: "string",
    regex: {
        rule: regex.source,
        flags: regex.flags,
        description
    }
});
